<template>
	<div class="park home_bg">
		<Header :title="title" :is_check="is_check" :farm_id="farm_id"></Header>
		<div style="width: 100%;height: 80px;"></div>
		<div class="main">
			<div class="nav_list" :default-active="defaultActive">

				<ul>

					<template v-for="(item, index) in navList">
						<li :key="item.link" :class="$route.path==item.link+'/'+farm_id?'active':''">
							 <router-link :to="item.link+'/'+farm_id">{{item.name}}</router-link>
							
						</li>
					</template>
				</ul>
			</div>
			<div class="content">
				<router-view></router-view>
			</div>
			   <div style="margin-top:20px;text-align: center; "><font color="white">备案号：渝ICP备18017663号-2  版权所有：三峡数字农业科技研究院</font></div>
		</div>
	</div>
</template>

<script>
	import Header from '@/components/Header';
	import {
		getFarmInfo
	} from '@/api/api'
	export default {
		name: "park",
		data() {
			return {
				title: '',
navList:[],
				navLists: [{
						"name": "园区总览",
						"link": "/park/detail"
					},
					{
						"name": "管理团队",
						"link": "/park/team"
					},
					{
						"name": "农事管理",
						"link": "/park/notFarming"
					},
					{
						"name": "智能诊断",
						"link": "/park/diagnosis"
					},
					{
						"name": "植物脸谱",
						"link": "/park/facial"
					},
					{
						"name": "生产效益",
						"link": "/park/benefit"
					},
					{
						"name": "病虫害",
						"link": "/park/insectPest"
					},
					{
						"name": "设备设施",
						"link": "/park/equipment"
					},
					{
						"name": "库存管理",
						"link": "/park/stock"
					},
					{
						"name": "销售管理",
						"link": "/park/sale"
					},
				],
				notOpen: false,
				farm_id: 0,
				is_check: 0,
user_position_code:0,

			}
		},
		methods: {

		},
		computed: {
			defaultActive() {
				return this.$route.path.replace('/', '');
			},
		},
		mounted() {
			console.log(this.$route)
		},
		created() {
			
			this.farm_id = parseInt(this.$route.params.id)
            // let name=["facial",]
			
			getFarmInfo(this.$route.params.id).then(resp => {


				this.is_check = resp.farm.is_check
				 if((this.is_check>=1) ){
					  console.log("daa")
				 } 
			    this.user_position_code=resp.user_position_code
				
				
					for (var i in this.navLists) {
						if(((this.navLists[i].name == '病虫害') && (resp.farm.pest_panel_close == 1)) ||  ((this.navLists[i].name == '植物脸谱') && (resp.farm.facial_panel_close == 1))){
							
						}else{
							this.navList.push(this.navLists[i])
						}
					}
				
				
	
				
				if (resp.farm.is_check == 1) {
					for (var i in this.navLists) {
						if (this.navLists[i].name == '农事管理') {
				
							this.navLists[i].link = "/park/farming"
				
						}
					}
				}
				
				this.farm_id = parseInt(resp.farm.id),
					this.title = resp.farm.name

			})



		},
		methods:{
			 click(){
				 console.log("aaa");
			 }
		},
		components: {
			Header
		}
	}
</script>

<style scoped lang="less">
	.park {
		.main {
			padding: 20px;

			.nav_list {
				ul {
					display: flex;

					li {
						width: 130px;
						height: 49px;
						line-height: 49px;
						background: url("../../assets/images/btn_bg.png") no-repeat;
						background-size: cover;

						a {
							display: block;
							width: 100%;
							font-size: 18px;
							//font-weight: 800;
							color: #2D99FF;
							text-align: center;
						}

						&+li {
							margin-left: 20px;
						}
					}

					.active {
						background: url("../../assets/images/btn_bg_01.png") no-repeat;
						background-size: cover;

						a {
							color: #fff;
						}
					}
				}
			}

			.content {
				padding-top: 15px;
			}
		}
	}
</style>
